import { React, useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import "./style.css";
import { useHistory } from "react-router";

const DoctorProfile = (props) => {
    const history = useHistory();

    const doctorOnClickHandler = () => {
        history.push("/about");
    };

    const [classState, setClassState] = useState("doctor-start");

    useEffect(() => {
        let listener = document.addEventListener("scroll", (e) => {
            let pos = document.getElementById(props.animationId);
            if (pos && pos.getBoundingClientRect().top <= (window.innerHeight * 3) / 4) {
                setClassState(props.animation);
            }
        });
        return () => {
            document.removeEventListener("scroll", listener);
        };
    });

    //TODO: use props
    return (
        <div className="col-lg-4 divider" style={{ marginBottom: "10% !important" }}>
            <Card className={classState} onClick={doctorOnClickHandler}>
                <Card.Img variant="top" src={props.img} width="100%" className="card-img" id={props.animationId} alt="doctor" />
                <div className="details">
                    <h1>{props.name}</h1>
                    <p>{props.specialisation}</p>
                </div>
            </Card>
        </div>
    );
};

export default DoctorProfile;
